
const FLUJOS_CONFIG = {
  landing_marco_mora: {
    tipo: "odontrut",
    valor: "10276218",
    descripcion: "Agendamiento Web - Marco Mora",
    sucursalesPermitidas: [1,2]
  },
  landing_mariaelsa_pavic: {
    tipo: "odontrut",
    valor: "8864606",
    descripcion: "Agendamiento Web - Maria Elsa Pavic",
    sucursalesPermitidas: [1,5]
  },
  landing_mauricio_prada: {
    tipo: "odontrut",
    valor: "14747403",
    descripcion: "Agendamiento Web - Mauruicio Prada",
    sucursalesPermitidas: [1,5]
  },
  demo_flujo: {
    tipo: "otroflujo",
    valor: "shortKey",
    descripcion: "Flujo de prueba técnica",
    sucursalesPermitidas: [1,2]
  }
};

export default FLUJOS_CONFIG;
